import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jswStandardUserModalTitleUrgent: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title-urgent',
		defaultMessage: 'Don’t lose access to unlimited users',
		description: 'Modal dialog urgent title that the Jira Standard plan has unlimted user ',
	},
	jswStandardUserModalSubTitleUrgent: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title-urgent',
		defaultMessage:
			'Your Standard trial ends on {trialEndDate}. Add payment or remove users to avoid deactivation.',
		description: 'Modal dialog urgent sub title that the Jira Standard plan has unlimted user',
	},
	jswStandardUserModalRemoveUsersLinkText: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-remove-users-link-text',
		defaultMessage: 'remove users',
		description: 'Remove users link text for user modal subtitle ',
	},
	jswStandardUserModalTitle: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title',
		defaultMessage: 'Keep adding your entire team',
		description: 'Modal dialog description that the Jira Standard plan has unlimted user',
	},
	jswStandardUserModalTitleNoPay: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title-no-pay',
		defaultMessage: 'Keep working with your entire team',
		description:
			'Modal dialog description that the Jira Standard plan has unlimted user cannot pay',
	},
	jswStandardUserModalSubTitle: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title',
		defaultMessage:
			'Your Standard trial ends on {trialEndDate}. Add payment or remove users to avoid deactivation.',
		description: 'Modal dialog sub title that the Jira Standard plan has unlimted use',
	},
	jswStandardUserModalTitleNoPayUrgent: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-title-no-pay-urgent',
		defaultMessage: 'Ask your admin to add payment for Jira Standard. Your trial ends on July 6.',
		description: 'Modal dialog carousel slide text for automation',
	},
	jswStandardUserModalSubTitleNoPayUrgent: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title-no-pay-urgent',
		defaultMessage:
			'Ask your admin to add payment for Jira Standard. Your trial ends on {trialEndDate}',
		description: 'Modal dialog carousel slide text for user permission',
	},
	jswStandardUserModalSubTitleNoPay: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-modal-sub-title-no-pay',
		defaultMessage:
			'Ask your admin to add payment for Jira Standard, so you can keep unlimited users. Your trial ends on {trialEndDate}.',
		description: 'Modal dialog carousel slide text for user permission',
	},
	jswStandardPrimaryCtaText: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-primary-cta-text',
		defaultMessage: 'Add payment',
		description: 'Modal dialog primary cta text for can pay',
	},
	jswStandardPrimaryCtaTextNoPay: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-primary-cta-text-no-pay',
		defaultMessage: 'Close',
		description: 'Modal dialog primary cta text for no pay',
	},
	jswStandardSecondaryCtaText: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-secondary-cta-text',
		defaultMessage: 'Maybe later',
		description: 'Modal dialog secondary cta text for can pay',
	},
	jswStandardUserAvatarTitle: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-avatar-title',
		defaultMessage: '{userCount} people added',
		description: 'Modal dialog user avatar title',
	},
	jswStandardUserAvatarSubTitle: {
		id: 'loss-aversion.loss-aversion-modal.user-limit.jsw-standard-user-avatar-sub-title',
		defaultMessage: 'Your team is over the Free plan’s limit of 10 users',
		description: 'Modal dialog user avatar sub title',
	},
});
